import { render } from "./Forum.vue?vue&type=template&id=1cd5a1ef&scoped=true"
import script from "./Forum.vue?vue&type=script&lang=js"
export * from "./Forum.vue?vue&type=script&lang=js"

import "quill-emoji/dist/quill-emoji.css?vue&type=style&index=0&lang=css"
import "./Forum.vue?vue&type=style&index=1&id=1cd5a1ef&lang=scss&scoped=true"

import exportComponent from "C:\\Development\\PircaGIT\\PircaSolutions.Forge.LMS\\PircaSolutions.Forge.LMS.Site.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cd5a1ef"]])

export default __exports__